import styled from 'styled-components';

const StyledThankYou = styled.div`

.alignCentre{
  text-align: center;
  margin-top: 30px;
  padding-bottom: 50px;
  padding-top:30px;
}

.ThankHeader{
  font-size:30px;
}

.MyOrderButton{
  background: ${(props) => props.theme.lightWhite};
  color: ${(props) => props.theme.primaryColor};
}
.card_no{
  font-size: 18px;
    font-weight: 600;
    margin-bottom: 20px;
    img{
      margin-bottom: -6px;
    margin-right: 10px;
    }
}
.CustomerSupport{
  font-size:13px;
  @media (max-width: ${({ theme: { breakpoints } }) => breakpoints[2]}) {
      padding:0px;
      margin:10px;
  };
}

.CustomerBold{
  font-weight: bold;
}

.CustomerSupportDetails{
  margin-top: -10px;
  padding-right: 30px;
  @media (max-width: ${({ theme: { breakpoints } }) => breakpoints[2]}) {
    margin:0px;
    padding:0px;
    display:inline-block;
    margin-bottom:20px;
  };
}

.DisplayFlex{
  display: flex;
  @media (max-width: ${({ theme: { breakpoints } }) => breakpoints[2]}) {
    display: inline-block;
    font-size:13px;
  };
}
`;

export default StyledThankYou;



// WEBPACK FOOTER //
// client/containers/ThankYou/StyledThankYou.js